module.exports = __webpack_public_path__ + "img/destination_serengeti.b10d33cb.jpg";